<template>
  <section id="experiencia">
    <div class="container">
      <title-vue title="Experiência Profissional" />
      <card-experience-vue
        v-for="(item, index) in itensCard"
        :key="index"
        :information="item"
      />
    </div>
  </section>
</template>

<script>
import TitleVue from "@/components/General/Title/Title.vue";
import CardExperienceVue from "@/components/Experience/CardExperience.vue";

export default {
  name: "ExperienceView",
  setup() {
    const itensCard = [
      {
        role: "Analista de Sistemas Júnior",
        company: "Welcome the Future",
        period: "abr de 2024 - o momento",
        location: "Salvador, Bahia, Brasil",
      },
      {
        role: "Programador Júnior",
        company: "Welcome the Future",
        period: "set de 2022 - abr de 2024",
        location: "Salvador, Bahia, Brasil",
      },
      {
        role: "Estagiário de mídia educacional",
        company: "Colégio Antônio Vieira",
        period: "nov de 2021 - out de 2022",
        location: "Salvador, Bahia, Brasil",
      },
    ];

    return { itensCard };
  },
  components: {
    TitleVue,
    CardExperienceVue,
  },
};
</script>

<style></style>
